import { useAuth0 } from '@auth0/auth0-react';
import {
    Box,
    Button,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Modal,
    Paper,
    Select,
    styled,
    Typography,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import axios from 'axios';
import React from 'react';
import TagsInput from '../BasicComponents/TagsInput';

const ModalPaper = styled(Paper)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: 24,
    margin: 4,
    [theme.breakpoints.down('sm')]: {
        width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
        width: '500px',
    },
}));

const re = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

export const InviteUsers = props => {
    const { getAccessTokenSilently } = useAuth0();
    const [emails, setEmails] = React.useState([]);
    const [accessRoles, setAccessRoles] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [error, setError] = React.useState('');
    const [sendingEmail, setSendingEmail] = React.useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleAccessRolesChange = event => {
        console.log('event', event.target);
        setAccessRoles(event.target.value);
    };

    function handleSelectedEmails(items) {
        setEmails(items);
    }

    const sendReqAccess = async e => {
        setSendingEmail(true);
        try {
            if (emails.length > 0) {
                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });

                const validEmails = emails.map(email => re.test(email));
                console.log(validEmails);
                if (!validEmails.every(Boolean)) {
                    props.setNotif(
                        'error',
                        0,
                        `Request contains invalid emails`
                    );
                } else {
                    const document = {
                        'users': emails,
                        'access':
                            accessRoles === 1
                                ? 'admin'
                                : accessRoles === 2
                                ? 'user'
                                : 'teacher',
                    };

                    const response = await axios.post(
                        '/sendReqAccess',
                        document,
                        {
                            baseURL: process.env.REACT_APP_API_GATEWAY,
                            timeout: 30000,
                            headers: {
                                authorization: `Bearer ${token}`,
                            },
                        }
                    );
                    if (response.status === 200) {
                        // props.setSnackBar(
                        //     true,
                        //     'success',
                        //     `Sent invitation emails`
                        // );
                        props.setNotif('success', 0, `Sent invitation emails`);
                        setEmails([]);
                        setOpen(false);
                    } else {
                        // props.setSnackBar(
                        //     true,
                        //     'error',
                        //     `Failed to send invitation emails`
                        // );
                        props.setNotif(
                            'error',
                            0,
                            `Failed to send invitation emails`
                        );
                    }
                }
            } else {
                setError('No Emails Listed');
            }
        } finally {
            setSendingEmail(false);
        }
    };

    return (
        <>
            <Button
                data-cy="invite-teachers"
                variant="contained"
                onClick={handleOpen}
                sx={{ margin: '16px' }}
            >
                Invite Users to airTeachr
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <ModalPaper>
                    <Box sx={{ margin: '20px', textAlign: 'center' }}>
                        <Typography variant="h4" sx={{ marginBottom: '16px' }}>
                            Send Emails to Invite Users
                        </Typography>
                        <FormControl>
                            <InputLabel id="invite-new-users-label">
                                Type of Access
                            </InputLabel>
                            <Select
                                labelId="invite-new-users"
                                data-cy="select-type"
                                id="invite-new-users"
                                value={accessRoles}
                                label="Invite Users to airTeachr"
                                onChange={handleAccessRolesChange}
                                sx={{ minWidth: '300px' }}
                            >
                                {props.schoolUser ? (
                                    <MenuItem value={1}>
                                        Invite New Admins
                                    </MenuItem>
                                ) : (
                                    <></>
                                )}
                                {props.schoolUser ? (
                                    <MenuItem value={2}>
                                        Invite Teaching Staff
                                    </MenuItem>
                                ) : (
                                    <></>
                                )}
                                <MenuItem value={3}>
                                    Invite Casual Relief Teachers
                                </MenuItem>
                            </Select>
                        </FormControl>
                        {(accessRoles === 1 ||
                            accessRoles === 2 ||
                            accessRoles === 3) && (
                            <FormControl>
                                <FormHelperText
                                    id="my-helper-text"
                                    sx={{ margin: 2 }}
                                >
                                    Enter an email address, press {' <Enter> '}{' '}
                                    to add multiple emails
                                </FormHelperText>
                                <TagsInput
                                    data-cy="emails"
                                    selectedTags={handleSelectedEmails}
                                    fullWidth
                                    variant="outlined"
                                    id="emails"
                                    name="emails"
                                    placeholder="Add Emails"
                                    label="emails"
                                />

                                <LoadingButton
                                    data-cy="submit"
                                    onClick={sendReqAccess}
                                    sx={{ marginTop: '16px' }}
                                    variant="outlined"
                                    disabled={sendingEmail}
                                    loading={sendingEmail}
                                >
                                    Submit
                                </LoadingButton>
                                {error !== '' && (
                                    <Typography color="error">
                                        {error}
                                    </Typography>
                                )}
                            </FormControl>
                        )}
                    </Box>
                </ModalPaper>
            </Modal>
        </>
    );
};

export default InviteUsers;
